import React from 'react';
import { useParams } from 'react-router-dom';
import qrERC20 from '../assets/qrcodes/erc20-qr.png';
import qrBEP20 from '../assets/qrcodes/bep20-qr.png';
import qrTRC20 from '../assets/qrcodes/trc20-qr.png';

const wallets = {
  ERC20: '0x4be19a1a2ecb95cf7561815a0bdc3bc943c1712b',
  BEP20: '0x4be19a1a2ecb95cf7561815a0bdc3bc943c1712b',
  TRC20: 'TRzoMKLaCoGCZroxUddGg7QJ27irmdpzsg'
};

export default function CryptoPaymentPage() {
  const { amount } = useParams();

  const handleCopy = (address) => {
    navigator.clipboard.writeText(address);
    alert('Wallet address copied!');
  };

  return (
    <div className="min-h-screen bg-[#0c0f2c] text-white flex items-center justify-center">
      <div className="flex flex-col items-center text-center w-full max-w-7xl px-4 py-10 space-y-10">
        
        <div>
          <h2 className="text-4xl font-bold mb-2">Crypto Payment</h2>
          <p className="text-gray-300 text-xl">
            Pay <span className="text-purple-400 font-bold text-2xl">${amount}</span> in USDT
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 w-full justify-items-center">
          {Object.entries(wallets).map(([network, address]) => {
            const qr =
              network === 'ERC20' ? qrERC20 :
              network === 'BEP20' ? qrBEP20 :
              qrTRC20;

            return (
              <div
                key={network}
                className="bg-[#1e223a] p-6 rounded-xl shadow-lg text-center flex flex-col items-center space-y-4 w-full max-w-sm"
              >
                <h3 className="text-2xl font-semibold text-purple-400">USDT - {network}</h3>
                <img src={qr} alt={`${network} QR`} className="w-[180px] h-[180px] rounded" />
                <p className="text-sm break-all text-gray-300 text-center max-w-full">{address}</p>
                <button
                  onClick={() => handleCopy(address)}
                  className="bg-gradient-to-r from-purple-600 to-pink-500 text-white px-6 py-2 rounded-lg font-semibold shadow hover:opacity-90 transition"
                >
                  Copy Wallet Address
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
